// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

const getUserEmailSessionItemsAndUpdateTimestamps = async ({
    test,
}: {
    test: boolean,
}): Promise<{
    email: string | null,
    sessions: string[],
    updated: number[],
}> => {
    const functions = getFunctions();
    const handleGetUserEmailSessionItemsAndUpdateTimestamps = httpsCallable<
        Record<
            string,
            boolean
        >,
        {
            email: string | null,
            sessions: string[],
            updated: number[],
        }
    >(
        functions,
        'getUserEmailSessionItemsAndUpdateTimestamps',
    );
    return handleGetUserEmailSessionItemsAndUpdateTimestamps({
        test,
    }).then((result) => {
        const userEmailSessionsAndTimestamps = result.data as {
            email: string | null,
            sessions: string[],
            updated: number[],
        };
        return userEmailSessionsAndTimestamps;
    }).catch((err) => {
        throw err;
    });
};

export default getUserEmailSessionItemsAndUpdateTimestamps;
